<script lang="ts">
  import { CORP } from "@spacecrew/shared";
  import { ship } from "../net/ship.svelte.js";
  import { leave, session } from "../net/session.svelte.js";
  import { audio } from "../audio/bus.js";
  import StatusStrip from "../components/StatusStrip.svelte";
  import DeckMap from "../components/DeckMap.svelte";
  import StationPanel from "../components/StationPanel.svelte";
  import CrewList from "../components/CrewList.svelte";
  import DevLine from "../components/DevLine.svelte";
  import IntercomBank from "../intercom/IntercomBank.svelte";
  import OverlayPlate from "../components/OverlayPlate.svelte";
  import StationView from "../station/StationView.svelte";
  import { defaultStationView } from "../lib/view.js";
  import CrtScreen from "../components/CrtScreen.svelte";
  import { screenSignal } from "../lib/signal.js";

  let muted = $state(audio.muted);
  function toggleMute() { audio.unlock(); muted = !muted; audio.setMuted(muted); }
  // Station view (first-person PSX room) is the game; the flat screen is the M1 debug view (?view=screen).
  let stationView = $state(defaultStationView());
</script>

{#if stationView}
  {@const me = ship.snap?.crew[session.sessionId]}
  {#key me?.nodeId}
  <StationView room={(me?.nodeId ?? "reactor") as "bridge" | "reactor" | "breaker_bay" | "storage"}>
    {#snippet screen()}
      <StatusStrip />
      <DeckMap compact />
      <StationPanel />
      <div class="crt-actions">
        <button class="tiny" aria-pressed={muted} onclick={toggleMute}>SPEAKER {muted ? "OFF" : "ON"}</button>
        <button class="tiny" onclick={() => { stationView = false; }}>VIEW: SCREEN</button>
        <button class="tiny" onclick={() => void leave()}>LOG OFF</button>
      </div>
    {/snippet}
    {#snippet monitors()}
      <IntercomBank />
    {/snippet}
  </StationView>
  {/key}
{:else}
<CrtScreen fill signal={screenSignal(ship.snap)} station={ship.snap?.crew[session.sessionId]?.nodeId ?? "reactor"}>
<div class="terminal">
  <header>
    <h1>{CORP} // HULL <span class="id">{ship.snap?.hullCode ?? ""}</span></h1>
    <div class="hdr-actions">
      <button onclick={() => { stationView = true; }} title="M2.5 spike: first-person PSX station">VIEW: STATION</button>
      <button aria-pressed={muted} onclick={toggleMute} title="Terminal sound effects.">SPEAKER {muted ? "OFF" : "ON"}</button>
      <button onclick={() => void leave()}>LOG OFF</button>
    </div>
  </header>

  <StatusStrip />

  <OverlayPlate flat />

  <IntercomBank />

  <div class="grid">
    <div class="left">
      <DeckMap />
      <CrewList />
    </div>
    <div class="right">
      <StationPanel />
    </div>
  </div>

  <section aria-labelledby="log-title">
    <h2 id="log-title">SHIP LOG</h2>
    <pre class="log" aria-live="off">{#each ship.events as e, i (i)}{e.text ? `${e.text}\n` : ""}{/each}</pre>
  </section>

  <DevLine />
</div>
</CrtScreen>
{/if}

<style>
  .tiny { min-height: 28px; padding: 0.2em 0.6em; font-size: 0.8em; }
  .crt-actions { display: flex; gap: 0.4rem; margin-top: 0.5rem; }
  .terminal { padding: 0.8rem 1rem; display: grid; gap: 0.9rem; max-width: 1200px; }
  header { display: flex; justify-content: space-between; align-items: center; gap: 1rem; flex-wrap: wrap; }
  .hdr-actions { display: flex; gap: 0.5rem; }
  .id { color: var(--fg); letter-spacing: 0.2em; user-select: all; }
  .grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 1rem; align-items: start; }
  .left { display: grid; gap: 1rem; }
  .log { border: 1px solid var(--fg-dim); padding: 0.6rem; max-height: 10em; overflow: auto; color: var(--fg-dim); }
</style>
